import styled from 'styled-components'

type Props = {
	isVisible: boolean
}

export const Label = styled.div<Props>`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};

	transition: opacity 0.4s;
`
